import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Input, Button, Form, Select, message, Tabs } from "antd";
import storageUtils from "../../utils/storageUtils";
import { getDateYYYYMMDD } from "../../utils/dateUtil";
import { req_add_pim_flexible_group } from "../../api";

const Item = Form.Item;
class FlexibleLogGroupAddModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    workStatusList: [
      { label: "停班", value: "PASS" },
      { label: "上班", value: "WORK" },
    ],
    weekdayNameList: [
      { label: "週一", value: "週一" },
      { label: "週二", value: "週二" },
      { label: "週三", value: "週三" },
      { label: "週四", value: "週四" },
      { label: "週五", value: "週五" },
    ],
    reasonList: [
      { label: "停班停課", value: "停班停課" },
      { label: "補休日", value: "補休日" },
      { label: "休息日", value: "休息日" },
      { label: "工作日", value: "工作日" },
      { label: "補班日", value: "補班日" },
    ],
    selectedWorkStatus: "WORK",
    selectedReason: "工作日",
    selectedWeekday: "週一",
    inputStartDate: getDateYYYYMMDD(new Date()),
    inputEndDate: getDateYYYYMMDD(new Date()),
    inputStartTime: "1300",
    inputEndTime: "2100",
    inputRestStart: "1730",
    inputRestEnd: "1800",
    inputRecordDescription: "",
    inputGroupDepartment: "人事室",
    inputAccordingDescription: "",
    item: {
      ClockType: "FLEXIBLE",
      WorkStatus: "WORK",
      ApplyStatus: "ALLAGREE",
      StartDate: getDateYYYYMMDD(new Date()),
      EndDate: getDateYYYYMMDD(new Date()),
      WeekdayName: "週一",
      StartTime: "1300",
      EndTime: "2100",
      RestStartTime: "1730",
      RestEndTime: "1800",
      RecordDescription: "",
      GroupDepartment: "人事室",
      AccordingDescription: "",
      OperatorCode: this.props.user.userCode,
    },
  };

  api_modify_item = async (item) => {
    const result = await req_add_pim_flexible_group(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  formatDate = (dateStr) => {
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    const day = dateStr.slice(6);

    return `${year}-${month}-${day}`;
  };

  // 操作互動處理 //////////////////////////////////////////////
  handleWorkStatusChange = (value) => {
    //console.log(value);
    this.setState({ selectedWorkStatus: value });
  };

  handleWeekdayChange = (value) => {
    //console.log(value);
    this.setState({ selectedWeekday: value });
  };

  handleReasonChange = (value) => {
    //console.log(value);
    this.setState({ selectedReason: value });
  };

  onFinish = (values) => {
    const { item, selectedWorkStatus, selectedWeekday } = this.state;
    //console.log("Success:", values);
    item.GroupName = values.inputGroupName;
    item.StartDate = this.formatDate(values.inputStartDate);
    item.EndDate = this.formatDate(values.inputEndDate);
    item.WeekdayName = selectedWeekday;
    item.StartTime = values.inputStartTime;
    item.EndTime = values.inputEndTime;
    item.WorkStatus = selectedWorkStatus;
    item.GroupDepartment = values.inputGroupDepartment;
    item.AccordingDescription = values.inputAccordingDescription;
    //console.log(item);
    this.api_modify_item(item);
  };

  render() {
    const {
      inputGroupName,
      inputStartDate,
      inputEndDate,
      inputStartTime,
      inputEndTime,
      selectedWeekday,
      //   inputRestStart,
      //   inputRestEnd,
      inputAccordingDescription,
      inputGroupDepartment,
      selectedWorkStatus,
      workStatusList,
      weekdayNameList,
    } = this.state;

    return (
      <Card>
        <Form onFinish={this.onFinish}>
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="基本資料" key="1">
              <>
                <Item
                  label="適用群體"
                  name="inputGroupName"
                  initialValue={inputGroupName}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="例：適用勞基法同仁" />
                </Item>
                <Item
                  label="作息狀態"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Select
                    defaultValue={selectedWorkStatus}
                    onChange={this.handleWorkStatusChange}
                    style={{
                      width: "100%",
                    }}
                    options={workStatusList}
                  />
                </Item>
                <Item
                  label="起始日期"
                  name="inputStartDate"
                  initialValue={inputStartDate}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="日期格式: 20240101" />
                </Item>
                <Item
                  label="結束日期"
                  name="inputEndDate"
                  initialValue={inputEndDate}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="日期格式: 20240101" />
                </Item>
                <Item
                  label="適用週別"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Select
                    defaultValue={selectedWeekday}
                    onChange={this.handleWeekdayChange}
                    style={{
                      width: "100%",
                    }}
                    options={weekdayNameList}
                  />
                </Item>
                <Item
                  label="作息起始時間"
                  name="inputStartTime"
                  initialValue={inputStartTime}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 0800" />
                </Item>
                <Item
                  label="作息結束時間"
                  name="inputEndTime"
                  initialValue={inputEndTime}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1700" />
                </Item>
              </>
            </Tabs.TabPane>
            <Tabs.TabPane tab="其他資料" key="2">
              <>
                {" "}
                {/* <Item
                  label="休息起始時間"
                  name="inputRestStart"
                  initialValue={inputRestStart}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1730" />
                </Item>
                <Item
                  label="休息結束時間"
                  name="inputRestEnd"
                  initialValue={inputRestEnd}
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "必須填寫內容",
                    },
                  ]}
                >
                  <Input placeholder="時間格式: 1800" />
                </Item> */}
                <Item
                  label="依據說明"
                  name="inputAccordingDescription"
                  initialValue={inputAccordingDescription}
                >
                  <Input placeholder="" />
                </Item>
                <Item
                  label="建置部門"
                  name="inputGroupDepartment"
                  initialValue={inputGroupDepartment}
                >
                  <Input placeholder="" />
                </Item>
                <Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="wave"
                    block
                  >
                    {"送出"}
                  </Button>
                </Item>
              </>
            </Tabs.TabPane>
          </Tabs>
        </Form>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(FlexibleLogGroupAddModal);
